import { render, staticRenderFns } from "./NumberListInput.vue?vue&type=template&id=0c865c52&scoped=true&"
import script from "./NumberListInput.vue?vue&type=script&lang=js&"
export * from "./NumberListInput.vue?vue&type=script&lang=js&"
import style0 from "./NumberListInput.vue?vue&type=style&index=0&id=0c865c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c865c52",
  null
  
)

export default component.exports